import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { Auth } from 'aws-amplify';
import { setLocalSession } from '@/utils/auth';
import { LoginFormWrapper, Warning } from '@/styles/auth.styles';
import Link from 'next/link';
import { signIn, useSession, getSession } from 'next-auth/client';

const ForgotPassConfirmationForm = ({ email }) => {
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [error, setError] = useState('');
  const [code, setCode] = useState('');

  const onSubmit = async e => {
    e.preventDefault();
    // console.log('submitting');
    await setLoading(true);
    await setError('');
    if (password !== passwordConfirm) {
      await setLoading(false);
      return setError('*Passwords must be equal');
    }
    if (!code || !email || !password) {
      await setLoading(false);
      return setError('*Please, fill the required fields');
    }

    try {
      await Auth.forgotPasswordSubmit(email, code, password);
      // console.log({ user });
      // console.log('Sign up successful, signing in');
      // console.log('trying credentials signin');
      // https://next-auth.js.org/getting-started/client#using-the-redirect-false-option
      const signResponse = await signIn('credentials', {
        username: email,
        password,
        redirect: false
      });
      // console.log({ signResponse });
      if (signResponse.error) {
        const respErr = JSON.parse(signResponse.error.replace('Error:', '').trim());
        // console.log({ respErr });
        throw respErr; // throw to catch
      }
      const userSession = await getSession();
      // console.log('pass signin');
      // console.log({ user });
      await setLocalSession(userSession);
      // await setLoading(false);
      router.push('/dashboard');
    } catch (err) {
      // console.log(err.message);
      let errMessage = err.message;
      await setError(err.message);
      if (
        err.message ===
        `1 validation error detected: Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6`
      ) {
        errMessage = `Password must have length greater than or equal to 6 characters`;
      }
      await setError(errMessage);
      await setLoading(false);
    }
  };

  return (
    <form onSubmit={onSubmit}>
      <div className="field-wrapper">
        <div className="label header">Code</div>
        <Warning centered>We have sent you a confirmation code to your email</Warning>
        <input
          type="text"
          name="code"
          placeholder="Enter Code"
          autoComplete="off"
          className="app-input"
          aria-label="Enter Code"
          onChange={e => setCode(e.target.value)}
          disabled={loading}
          value={code}
        />
      </div>

      <div className="field-wrapper">
        <div className="label">Password</div>
        <input
          type="password"
          name="password"
          placeholder="Enter your password"
          autoComplete="new-password"
          className="app-input"
          aria-label="Enter your password"
          onChange={e => setPassword(e.target.value)}
          disabled={loading}
          value={password}
        />
      </div>

      <div className="field-wrapper">
        <div className="label">Password confirm</div>
        <input
          type="password"
          name="passwordConfirm"
          // passwordShowHide
          placeholder="Confirm your password"
          autoComplete="new-password"
          className="app-input"
          aria-label="Confirm your password"
          onChange={e => setPasswordConfirm(e.target.value)}
          disabled={loading}
          value={passwordConfirm}
        />
      </div>

      <div className="field-wrapper submit">
        <button type="submit" disabled={loading}>
          {loading ? 'Signin in...' : 'Change password'}
        </button>
      </div>
      {error && (
        <div className="field-wrapper error">
          <Warning>{error}</Warning>
        </div>
      )}
    </form>
  );
};

const ForgotPasswordForm = () => {
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  const [confirmation, setConfirmation] = useState(false);
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [session, sessionLoading] = useSession();

  useEffect(() => {
    const sessionLogin = async () => {
      // have session
      // console.log('useeffect signin');
      // console.log({ session });
      await setLocalSession(session);
      // redirect??
      if (router) {
        router.replace('/dashboard');
      }
    };
    if (!sessionLoading && session) {
      sessionLogin();
    }
  }, [session, sessionLoading, router]);

  const onSubmit = async e => {
    e.preventDefault();
    // console.log('submitting');
    await setLoading(true);
    await setError('');

    if (!email) {
      await setLoading(false);
      return setError('*Please, fill the required fields');
    }

    try {
      await Auth.forgotPassword(email);
      await setLoading(false);
      await setConfirmation(true);
    } catch (err) {
      // console.log(err.message);
      // console.log({ err: err.message });
      let errMessage = err.message;
      await setError(err.message);
      if (err.code === 'UserNotFoundException') {
        errMessage = `Email ${email} is not registered. If you do have an account, try login with Google`;
      }
      await setError(errMessage);
      await setLoading(false);
    }
  };

  return (
    <LoginFormWrapper>
      <div className="app-login">
        <div className="login-title">Password Recovery</div>
        {confirmation ? (
          <ForgotPassConfirmationForm email={email} />
        ) : (
          <form onSubmit={onSubmit}>
            <div className="field-wrapper">
              <div className="info-field">
                Enter your Email to receive a recovery code to your email. You must use that code to
                create your new password.
              </div>
            </div>
            <div className="field-wrapper">
              <div className="label">Email</div>
              <input
                type="text"
                name="email"
                placeholder="e.g. email@example.com"
                autoComplete="username"
                className="app-input"
                aria-label="e.g. email@example.com"
                onChange={e => setEmail(e.target.value)}
                disabled={loading}
                value={email}
              />
            </div>

            <div className="field-wrapper submit">
              <button type="submit" disabled={loading}>
                {loading ? 'Sending...' : 'Send password recovery code'}
              </button>
            </div>
            {error && (
              <div className="field-wrapper error">
                <Warning>{error}</Warning>
              </div>
            )}
          </form>
        )}
        {/* <br /> */}
        <div className="login-form-switch">
          Already have an account?{' '}
          <Link href="/login">
            <a>Sign In</a>
          </Link>
          <br />
          Don't have an account yet?{' '}
          <Link href="/signup">
            <a>Sign Up</a>
          </Link>
        </div>
      </div>
    </LoginFormWrapper>
  );
};

export default ForgotPasswordForm;
